import { useDispatch } from "react-redux";

import TextComboInput from "@shared/v2/TextComboInput";

import { useContactPerson } from "../../../reducers/contactsReducer/selectors";
import { setPersonValue } from "../../../reducers/contactsReducer";

const Title = () => {
  const dispatch = useDispatch();
  const { jobTitle } = useContactPerson();
  return (
    <TextComboInput
      label="Title / Designation"
      value={jobTitle}
      onChange={(e) => dispatch(setPersonValue({ key: "jobTitle", value: e.target.value }))}
      toolTipInfoContent={
        <div className="tw-w-[180px] tw-text-left">
          Displays as your job title on your Brivity website. <b>Example:</b> Buyer’s Agent, Showing
          Assistant, Team Leader
        </div>
      }
      toolTipPlacement="right"
    />
  );
};

export default Title;
